<template>
    <div class="service">
        <HeaderReturn title="联系客服"></HeaderReturn>

        <div class="service_ul">
            <div>
                <img src="../../assets/img/page/kf.png" />
                <p>TY 客服</p>
            </div>
        </div>
    




    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    txt: "APP版本",
                    id: 0,
                    path: ''
                },
                {
                    txt: "安全中心",
                    id: 1,
                    path: '/My/withdrawal'

                },
                {
                    txt: "订单客服",
                    id: 2
                },
                {
                    txt: "联系客服",
                    id: 3
                }, {

                    txt: "关于我们",
                    id: 4
                }
            ],



        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
    },
    methods: {
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        item: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.service {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .service_btn {
        /* Frame 147 */


        /* Auto layout */

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;

        position: absolute;
        width: 345px;
        height: 42px;
        left: 15px;
        top: 735px;

        /* 黄/主题 */

        background: #f89b19;
        border-radius: 4px;
        color: #FFFFFF;
    }

    .service_ul {

        margin: 162px 0;

        img {
            width: 166px;
            height: 166px;

        }

        text-align: center;
    }




}</style>